<template>
  <div>
    <input 
      class="ackInput"
      type="checkbox" 
      v-model="isAcknowledged"
      @click="acknowledge"
      :disabled="isAcknowledged"
    />
  </div>
</template>

<script>
export default {
  name: 'AcknowledgeButton',
  props: {
    source: {
      type: String,
      required: true,
    },
    ack: {
      type: String,
      required: true,
    },
    id: {
      type: Number,
      required: true
    }
  },
  computed: {
    buttonColorClass() {
      if (this.source === 'VEHICLE') {
        return 'acknowledge-button-green';
      } else if (this.source === 'DISPLAY') {
        return 'acknowledge-button-yellow';
      } else if (this.source === 'TIMETABLE') {
        return 'acknowledge-button-red';
      }
      return 'acknowledge-button-default';
    },
    isAcknowledged() {
      return this.ack === 'AUTO' || this.ack === 'USER';
    }
  },
  methods: {
    acknowledge() {
      let params = {
        id: this.id,
        ack: 'USER'
      }
      this.$emit('updateAck', params);
    }
  }
};
</script>


<style scoped lang="scss">
.ackInput {
  width:25px;
  height:25px;
  border-radius:5px;
  border:2px solid #555;
}
</style>
